import axios from "axios";

const CLOUD_NAME = "dkw54nmes";
const UPLOAD_PRESET = "Santalum";

export const uploadImageToCloudinary = async (file, folder = "") => {
    try {
        const formData = new FormData();

        formData.append("file", file);
        formData.append("upload_preset", UPLOAD_PRESET);

        if (folder) {
            formData.append("folder", folder);
        }

        const response = await axios.post(
            `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
            formData
        );

        return response.data.secure_url;
    } catch (error) {
        console.error("Cloudinary Upload Error:", error);
        throw error;
    }
};